import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WelcomePage.css';

const WelcomePage = () => {
  const navigate = useNavigate();

  const handleYemeksepetiClick = () => {
    window.open('https://www.yemeksepeti.com/en/restaurant/pjy9/hasim-usta-kebap', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='welcome-container'>
      <h1 className='restaurant-title'>Haşim Usta Kebab</h1>
      <div className='button-group'>
        <button className='menu-button' onClick={() => navigate('/menu')}>
          Menüye Git
        </button>
        <button className='yemeksepeti-button' onClick={handleYemeksepetiClick}>
          <span>🛒</span>
          Yemek Sepeti
        </button>
      </div>
    </div>
  );
};

export default WelcomePage;
